// extracted by mini-css-extract-plugin
export default {"header":"HeaderSimple_header__qUEEI","link":"HeaderSimple_link__2YwiZ","linkSmall":"HeaderSimple_linkSmall__yh8j4","inputSearch":"HeaderSimple_inputSearch__YysKa"};